import '../assets/styles/App.css';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import { getCookie, setCookie } from '../cookie/cookies';
import Footer from '../components/Footer';

function Lab() {
    const data = require('../assets/data/data.json');
    let navigate = useNavigate();

    useEffect(() => {
        // window.location.replace('https://tumblbug.com/tear_by_bit');
    }, []);

    const routeChange = (isInternal, path, e) => {
        e.preventDefault();
        if (isInternal) {
            let newPath = path;
            navigate(newPath);
        } else {
            window.open(path);
        }
    };
    return (
        <div className='App'>
            <Header header={'Lab'} />
            {data.products.map((product, index) => {
                return (
                    <div className='product' key={index}>
                        <img
                            className='product-image'
                            src={require(`../assets/images/${product.id}.png`)}
                        />

                        <div className='product-info'>
                            <div className='product-name'>{product.name}</div>
                            <div className='product-price'>
                                ₩{product.price.slice(0, -3)},
                                {product.price.slice(-3)}
                            </div>
                            <div>
                                <button
                                    // onClick={(e) =>
                                    //     routeChange(
                                    //         true,
                                    //         `/lab/${product.id}/`,
                                    //         e
                                    //     )
                                    // }
                                    className='order-button'
                                >
                                    품절
                                </button>
                            </div>
                        </div>
                    </div>
                );
            })}
            <Footer />
        </div>
    );
}

export default Lab;
